import { Component, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, of } from 'rxjs';
import { ProgressBarService } from './progress-bar.service';
import { IProgressBarComponent } from '@app/shared/models/dialog/progress-bar';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnDestroy {
  progressValue$: Observable<number>;
  progressGoal: number;
  message: string;
  declineText: string;
  title: string;
  progressSubscription: Subscription;
  currentProgress = 0;
  type: string;

  Types = {
    UPLOAD: 'upload',
    DEFAULT: 'default',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IProgressBarComponent,
    public translate: TranslateService,
    private _router: Router,
    private dialogRef: MatDialogRef<ProgressBarComponent>,
    private progressBarService: ProgressBarService
  ) {
    this.message = this.data.message;
    this.declineText = this.data.declineText;
    this.progressValue$ = this.data.progressValue$;
    this.title = this.data.title;
    this.progressGoal = this.data.progressGoal;
    this.type = this.data.type;

    this.progressSubscription = this.progressBarService.progress$.subscribe((progressCount: number) => {
      this.currentProgress += progressCount;
      this.progressValue$ = of((this.currentProgress / this.progressGoal) * 100);
    });
  }

  ngOnDestroy() {
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }
  }

  goToDashboard() {
    this._router.navigateByUrl('/instrumententafel');
    this.dialogRef.close();
  }
}
